import cx from "classnames";
import { createBrowserHistory } from 'history';
import React, { Component, Fragment } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { Button } from 'reactstrap';
import city3 from '../../assets/utils/images/dropdown-header/city3.jpg';
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import { client } from '../../services';
import * as storageService from '../../utils/storage';
import HeaderLogo from "../AppLogo";
import Nav from "../AppNav/VerticalNavWrapper";

class AppSidebar extends Component {
  state = {};
  user = storageService.getItem('USER_CURRENT');
  history = createBrowserHistory({ forceRefresh: true });

  toggleMobileSidebar = () => {
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };

  logout = () => {
    client.setHeader('user_current', null);
    client.setHeader('token', null);
    storageService.removeItem('TOKEN');
    storageService.setCurrentUser(null)
    this.history.push({ pathname: '#/login' });
    window.location.reload();
  };

  goProfile = () => {
    this.history.push({ pathname: `#/profile` });
    window.location.reload();
  };

  render() {
    let {
      backgroundColor,
      enableBackgroundImage,
      enableSidebarShadow,
      backgroundImage,
      backgroundImageOpacity,
    } = this.props;

    return (
      <Fragment>
        <div className="sidebar-mobile-overlay" onClick={this.toggleMobileSidebar} />
        <CSSTransitionGroup component="div"
          className={cx("app-sidebar", backgroundColor, {
            "sidebar-shadow": enableSidebarShadow,
          })}
          transitionName="SidebarAnimation" transitionAppear={true} transitionAppearTimeout={1500}
          transitionEnter={false} transitionLeave={false}>
          <HeaderLogo />
          <PerfectScrollbar>
            <div className="app-sidebar__inner">
              <Nav />

              <div className="dropdown-menu-header mt-2">
                <div className="dropdown-menu-header-inner bg-info">
                  <div
                    className="menu-header-image opacity-2"
                    style={{
                      backgroundImage: 'url(' + city3 + ')',
                    }}
                  />
                  <div className="menu-header-content text-left">
                    <div className="widget-content p-0">
                      <div className="widget-content-wrapper">
                        <div className="widget-content-left">
                          <div className="widget-heading">{this.user.name}</div>
                          <div className="widget-subheading opacity-8">{this.user.role_title}</div>
                          <div className="widget-heading"><Link to='/profile' style={{ color: 'white' }}>Profile</Link></div>
                        </div>
                        <div className="widget-content-right mr-2">
                          <Button
                            className="btn-pill btn-shadow btn-shine"
                            color="focus"
                            onClick={this.logout}
                          >Logout</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </PerfectScrollbar>
          <div className={cx("app-sidebar-bg", backgroundImageOpacity)}
            style={{
              backgroundImage: enableBackgroundImage
                ? "url(" + backgroundImage + ")"
                : null,
            }}>
          </div>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
  backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);
